import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import {
  withCombinedStyles,
  withComposedEnhancers
} from '../../../utils/hocUtils';

import { Link } from 'react-router-dom';
import { withNamespaces } from 'react-i18next';
import {
  Card,
  Grid,
  CardHeader,
  CardContent,
  Typography,
  Button,
  Divider
} from '@material-ui/core';
import LoadingOrError from '../../LoadingOrError';

import DonutGauge from '../../../components/Global/Graphs/DonutGauge';
import TypographyStyles from '../../../styles/typography';
import LayoutStyles from '../../../styles/layout';
import ReportStyles from '../../../pages/reports/Report.styles';

const localStyles = {
  donutGauge: {
    width: '75px'
  }
};

const CarrierPerformanceGridRow = ({
  theme,
  classes,
  percent,
  percentLabel,
  count,
  totalLabel
}) => (
  <Grid container spacing={8}>
    <Grid container item spacing={8} xs={8}>
      <Grid item className={classes.donutGauge}>
        <DonutGauge
          percent={percent}
          cutoutPercentage={85}
          color={theme.palette.primary.main}
          remainderColor={theme.palette.background.default}
          animate={false}
          height={50}
          width={50}
        />
      </Grid>
      <Grid item>
        <Typography component="div" className={classes.cardStat} gutterBottom>
          {percent}%
        </Typography>
        <Typography component="div" className={classes.cardLabel} gutterBottom>
          {percentLabel}
        </Typography>
      </Grid>
    </Grid>
    <Grid item xs={4}>
      <Typography
        component="div"
        className={classes.cardStat}
        align="right"
        gutterBottom
      >
        {count}
      </Typography>
      <Typography
        component="div"
        className={classes.cardLabel}
        align="right"
        gutterBottom
      >
        {totalLabel}
      </Typography>
    </Grid>
  </Grid>
);

const CarrierPerformanceSummary = props => {
  const { t, classes, fillHeight, data, loading, error } = props;
  const cardStyle = {};
  if (fillHeight) cardStyle.height = '100%';

  return (
    <Card square style={cardStyle}>
      <CardHeader
        title={t('Carrier Performance')}
        action={
          <Button
            component={Link}
            to="/reports/carrier-performance"
            color="primary"
          >
            {t('View')}
          </Button>
        }
        classes={{ title: classes.headline6 }}
      />
      <Divider />
      <CardContent>
        {!loading && !error && (
          <Fragment>
            <CarrierPerformanceGridRow
              {...props}
              percent={data.percentOnTimeForDelivery}
              percentLabel={t('Deliveries On-Time')}
              count={data.numDelivered}
              totalLabel={t('Total Deliveries')}
            />
            <CarrierPerformanceGridRow
              {...props}
              percent={data.percentOnTimeForPickup}
              percentLabel={t('Pickups On-Time')}
              count={data.numPickedUp}
              totalLabel={t('Total Pickups')}
            />
          </Fragment>
        )}
        <LoadingOrError
          loading={loading}
          error={error}
          classes={{ root: classes.loadingOrError }}
        />
      </CardContent>
    </Card>
  );
};

CarrierPerformanceSummary.propTypes = {
  data: PropTypes.object
};

export default withComposedEnhancers(
  CarrierPerformanceSummary,
  withNamespaces(),
  withCombinedStyles(
    true,
    TypographyStyles,
    LayoutStyles,
    ReportStyles,
    localStyles
  )
);
